<template>
    <div :class="classes">
        <slot />
    </div>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';

    @Component
    export default class WorkScheduleContainerColumn extends Vue {
        @Prop({type: Boolean}) public headerColumn!: boolean;
        @Prop({type: Boolean}) public noPadding!: boolean;
        @Prop({type: Boolean}) public timeGrid!: boolean;
        @Prop({type: Boolean}) public stickyLeft!: boolean;

        public get classes(): Record<string, boolean> {
            return {
                column: true,
                headerColumn: this.headerColumn,
                noPadding: this.noPadding,
                timeGrid: this.timeGrid,
                stickyLeft: this.stickyLeft,
            };
        }
    }
</script>

<style scoped lang="scss">
    .column {
        padding: var(--cell-padding);
        border-bottom: 1px solid var(--work-schedule-border-color);
        --horizontal-gradient: repeating-linear-gradient(90deg,
            transparent 0,
            transparent calc(var(--hour-cell-width) - 1px),
            var(--work-schedule-border-color) calc(var(--hour-cell-width) - 1px),
            var(--work-schedule-border-color) var(--hour-cell-width)
        );

        @media only screen and (width <= 576px) {
            --horizontal-gradient: repeating-linear-gradient(90deg,
                transparent 0,
                transparent calc(3 * var(--hour-cell-width) - 1px),
                var(--work-schedule-border-color) calc(3 * var(--hour-cell-width) - 1px),
                var(--work-schedule-border-color) calc(3 * var(--hour-cell-width))
            );
        }

        &.headerColumn {
            background: var(--modal-background);
        }

        &.noPadding {
            padding: 0;
        }

        &.timeGrid {
            padding: 0;
            display: grid;
            grid-template-columns: subgrid;
            width: calc(var(--roster-date-range-in-hours) * var(--hour-cell-width)); // CHECK
            background-image: var(--horizontal-gradient);
            background-color: var(--work-schedule-grid-background-color);
        }

        &.stickyLeft {
            width: var(--label-cell-width);
            position: sticky;
            left: 0;
            z-index: 2;
            background: var(--modal-background);
            border-right: 1px solid var(--work-schedule-border-color);
        }
    }
</style>
